import { render, staticRenderFns } from "./WinesButton.vue?vue&type=template&id=028016f7"
import script from "./WinesButton.vue?vue&type=script&lang=ts"
export * from "./WinesButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports